type ViteEnv = {
    DEV?: boolean;
    VITE_API_BASE_URL?: string;
    VITE_SOCKET_URL?: string;
};

export const APP_ENV: ViteEnv = import.meta.env as ViteEnv;

export const IS_DEV = Boolean(APP_ENV.DEV);
